'use client'

import { useLocation } from 'react-router-dom'

import { useActivePatient } from '@/context/ActivePatientContext'
import { ClinicalSummaryOverview } from '@/components/patient/ClinicalSummaryOverview'
import { DiagnosticoTab } from './DiagnosticoTab'

/**
 * Main workspace content for the Resumen / Diagnóstico tabs (same route component).
 *
 * The "Resumen" (Summary) section is the read-only, auto-updated clinical
 * overview derived from signed notes / locked records — it answers "what do I
 * need to know about this patient right now?" and is never directly editable.
 * The full identification card lives in "Datos del Paciente"; the active
 * consultation and editable diagnostic summary live in the Diagnóstico section.
 */
export function ResumenDiagnosticoTab() {
  const location = useLocation()
  const { activePatientData } = useActivePatient()
  const isResumen = location.pathname.endsWith('/resumen')

  if (isResumen) {
    if (!activePatientData) return null
    return <ClinicalSummaryOverview patientId={activePatientData.id} />
  }

  return <DiagnosticoTab />
}
